import React, { useState, useEffect } from 'react';
import { ChevronDown } from 'lucide-react';
import { typewriterTexts } from '../data/sections';

const HeroSection = ({ scrollToSection, showScrollHint }) => {
  const [rocketLaunched, setRocketLaunched] = useState(false);
  const [typedText, setTypedText] = useState('');

  // Simple Typewriter Effect
  useEffect(() => {
    let textIndex = 0;
    let charIndex = 0;
    let isDeleting = false;
    
    const typeEffect = () => {
      const currentText = typewriterTexts[textIndex];
      
      if (!isDeleting && charIndex <= currentText.length) {
        setTypedText(currentText.slice(0, charIndex));
        charIndex++;
        
        if (charIndex > currentText.length) {
          setTimeout(() => {
            isDeleting = true;
          }, 2000);
        }
      } else if (isDeleting && charIndex >= 0) {
        setTypedText(currentText.slice(0, charIndex));
        charIndex--;
        
        if (charIndex < 0) {
          isDeleting = false;
          textIndex = (textIndex + 1) % typewriterTexts.length;
          charIndex = 0;
        }
      }
    };
    
    const timer = setInterval(typeEffect, isDeleting ? 50 : 100);
    return () => clearInterval(timer);
  }, []);

  const launchRocket = () => {
    setRocketLaunched(true);
    setTimeout(() => setRocketLaunched(false), 3000);
  };

  return (
    <section id="hero" className="min-h-screen flex items-center justify-center relative overflow-hidden">
      {/* Rocket Animation */}
      <div className={`absolute transition-all duration-3000 ${
        rocketLaunched ? 'bottom-full right-10 scale-150' : 'bottom-20 right-10'
      }`}>
        <div className="text-6xl animate-bounce">🚀</div>
      </div>

      <div className="text-center z-10 max-w-4xl mx-auto px-4 relative">
        <div className="mb-6">
          <h1 className="text-5xl md:text-7xl font-bold text-gray-800 mb-4">
            Singh Sakshi
          </h1>
          <p className="text-xl text-gray-600 mb-2">Application Number:PF0243457</p>
          <div className="h-16 flex items-center justify-center">
            <p className="text-3xl text-blue-600 font-medium">
              {typedText}
              <span className="animate-pulse text-blue-400">|</span>
            </p>
          </div>
        </div>
        
        <div className="space-y-4">
          <button
            onClick={launchRocket}
            className="bg-gradient-to-r from-blue-600 to-purple-600 text-white px-8 py-4 rounded-full font-semibold text-lg hover:scale-105 transition-transform shadow-lg hover:shadow-xl relative overflow-hidden group"
          >
            <span className="relative z-10">Launch My Appeal 🚀</span>
            <div className="absolute inset-0 bg-gradient-to-r from-purple-600 to-pink-600 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
          </button>
          
          <div className="flex justify-center gap-4">
            <button
              onClick={() => scrollToSection('about')}
              className="border-2 border-blue-600 text-blue-600 px-6 py-3 rounded-full font-medium hover:bg-blue-600 hover:text-white transition-colors"
            >
              🚀 Explore My Journey
            </button>
          </div>
        </div>
      </div>

      {/* Scroll Hint */}
      {showScrollHint && (
        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
          <div className="flex flex-col items-center text-gray-400">
            <span className="text-sm mb-2">Scroll to unlock my story</span>
            <ChevronDown size={32} />
          </div>
        </div>
      )}
    </section>
  );
};

export default HeroSection;